// extracted by mini-css-extract-plugin
export default {"Wrapper":"OhNo_Wrapper__jIxHM","Alternative":"OhNo_Alternative__FpigD","ContactUs":"OhNo_ContactUs__VO3H0"};